// extracted by mini-css-extract-plugin
module.exports = {"main":"RadioBox_main__1S_24","label":"RadioBox_label__3GrDr","radioContainer":"RadioBox_radioContainer__2Wspi"};